import { CollectionEntity } from "@busy-human/gearbox";
import { z } from "zod";
export var DonationLinks;
(function (DonationLinks) {
    DonationLinks.ModelSchema = z.object({
        builderName: z.object({
            fullName: z.string().trim().optional(),
            firstName: z.string().trim().default(""),
            lastName: z.string().trim().default(""),
            preferredName: z.string().trim().optional()
        }).transform(a => {
            // Make sure fullname is always 'firstname lastname'
            if (a.firstName && a.lastName)
                a.fullName = `${a.firstName} ${a.lastName}`;
            return a;
        }).default({}),
        seasonId: z.string(),
        builderId: z.string(),
        userId: z.string()
    });
    function Default() {
        return DonationLinks.ModelSchema.parse({
            builderName: {
                firstName: '',
                lastName: '',
            },
            seasonId: '',
            builderId: '',
            userId: ''
        });
    }
    DonationLinks.Default = Default;
    function Validate(obj) {
        return DonationLinks.ModelSchema.parse(obj);
    }
    DonationLinks.Validate = Validate;
    const LONG_NAME_ID_DIGITS = 4;
    const SHORT_NAME_ID_DIGITS = 8;
    function generateId(obj) {
        if (obj.builderName.firstName && obj.builderName.lastName) {
            const numbers = Math.floor(Math.random() * (10 ** LONG_NAME_ID_DIGITS));
            return `${obj.builderName.firstName}-${obj.builderName.lastName}-${numbers}`;
        }
        else if (obj.builderName.firstName) {
            const numbers = Math.floor(Math.random() * (10 ** SHORT_NAME_ID_DIGITS));
            return `${obj.builderName.firstName}-${numbers}`;
        }
        else if (obj.builderName.preferredName) {
            const numbers = Math.floor(Math.random() * (10 ** SHORT_NAME_ID_DIGITS));
            return `${obj.builderName.preferredName}-${numbers}`;
        }
    }
    DonationLinks.generateId = generateId;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return Default();
        }
    }
    DonationLinks.CollectionClass = CollectionClass;
    DonationLinks.Collection = new CollectionClass({ path: '/DonationLinks' });
})(DonationLinks || (DonationLinks = {}));
//# sourceMappingURL=index.js.map